export default "__VITE_ASSET__DzPRFUKk__"